import script from "./UploadClassificationsImage.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadClassificationsImage.vue?vue&type=script&setup=true&lang=js"

export default script